import {
  Environment
} from '@vodacom/web-env';

import {
  AppState,
  getStorageWithExpiry,
  mapSendOtp,
  mapSendOtpv2,
  mapSendUserOtp,
  mapSendUserOtpv2,
  mapVerifyOtp,
  mapVerifyOtpv2,
  mapVerifyUserOtp,
  mapVerifyUserOtpv2,
  setStorageWithExpiry
} from 'helpers';

export class AuthProvider {

  static BASE_URL = Environment.current.authHost + Environment.current.authBase;
  static BASE_URL_V2 = Environment.current.authHostv2 + Environment.current.authBase;
  static STATE = AppState.with('AuthProvider');

  static getMsisdn() {

    return getStorageWithExpiry('msisdn', 'encMsisdn', '');
  }

  static async requestOtp() {

    return AuthProvider.STATE.makeServiceCall(
      `${AuthProvider.BASE_URL}otp`,
      {
        method: 'POST',
        headers: {},
        bodyParams: {
          'id': AuthProvider.getMsisdn()
        },
        mapper: mapSendOtp
      }
    )
      .then((res) => {

        if (!res.result) {

          return {
            ok: false,
            error: new Error('Error with Otp request'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        return res;
      })
      .catch((error) => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: null,
          code: error?.response?.status,
          stamp: new Date()
        };
      });
  }

  static async requestOtpv2() {

    return AuthProvider.STATE.makeServiceCall(
      `${AuthProvider.BASE_URL_V2}otp`,
      {
        method: 'POST',
        headers: {},
        bodyParams: {
          'id': AuthProvider.getMsisdn()
        },
        mapper: mapSendOtpv2
      }
    )
      .then((res) => {

        if (!res.result) {

          return {
            ok: false,
            error: new Error('Error with requestOtpv2, no result property found'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        return res;
      })
      .catch((error) => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: error?.response?.data,
          code: error?.response?.status,
          stamp: new Date()
        };
      });
  }

  static async verifyOtp(
    otp
  ) {

    return AuthProvider.STATE.makeServiceCall(
      `${AuthProvider.BASE_URL}otp/status`,
      {
        method: 'POST',
        headers: {},
        bodyParams: {
          'id': AuthProvider.getMsisdn(),
          'pto': otp
        },
        mapper: mapVerifyOtp
      }
    )
      .then((res) => {

        if (!res.result) {

          return {
            ok: false,
            error: new Error('Otp verification error'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        return res;
      })
      .catch((error) => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: null,
          code: error?.response?.status,
          stamp: new Date()
        };
      });
  }

  static async verifyOtpv2(
    otp
  ) {

    return AuthProvider.STATE.makeServiceCall(
      `${AuthProvider.BASE_URL_V2}otp/status`,
      {
        method: 'POST',
        headers: {},
        bodyParams: {
          'id': AuthProvider.getMsisdn(),
          'pto': otp
        },
        mapper: mapVerifyOtpv2
      }
    )
      .then((res) => {

        if (!res.result) {

          return {
            ok: false,
            error: new Error('Error with verifyOtpv2, no result property found'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        return res;
      })
      .catch((error) => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: error?.response?.data,
          code: error?.response?.status,
          stamp: new Date()
        };
      });
  }

  static async requestUserOtp() {

    return AuthProvider.STATE.makeServiceCall(
      `${AuthProvider.BASE_URL}otp/user`,
      {
        method: 'POST',
        headers: {},
        bodyParams: {
          'id': AuthProvider.getMsisdn()
        },
        mapper: mapSendUserOtp
      }
    )
      .then((res) => {

        if (!res.result) {

          return {
            ok: false,
            error: new Error('Error with Otp request'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        setStorageWithExpiry('Msisdn', 'msisdnMasked', res?.result?.msisdnMasked);

        return res;
      })
      .catch((error) => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: null,
          code: error?.response?.status,
          stamp: new Date()
        };
      });
  }

  static async requestUserOtpv2() {

    return AuthProvider.STATE.makeServiceCall(
      `${AuthProvider.BASE_URL_V2}otp/user`,
      {
        method: 'POST',
        headers: {},
        bodyParams: {
          'id': AuthProvider.getMsisdn()
        },
        mapper: mapSendUserOtpv2
      }
    )
      .then((res) => {

        if (!res.result) {

          return {
            ok: false,
            error: new Error('Error with requestUserOtpv2, no result property found'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        setStorageWithExpiry('Msisdn', 'msisdnMasked', res?.result?.msisdnMasked);

        return res;
      })
      .catch((error) => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: error?.response?.data?.result,
          code: error?.response?.status,
          stamp: new Date()
        };
      });
  }

  static async verifyUserOtp(
    otp
  ) {

    return AuthProvider.STATE.makeServiceCall(
      `${AuthProvider.BASE_URL}otp/user/status`,
      {
        method: 'POST',
        headers: {},
        bodyParams: {
          'id': AuthProvider.getMsisdn(),
          'pto': otp
        },
        mapper: mapVerifyUserOtp
      }
    )
      .then((res) => {

        if (!res.result) {

          return {
            ok: false,
            error: new Error('Otp verification error'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        setStorageWithExpiry('Auth', 'token', res.result.access_token);

        return res;
      })
      .catch((error) => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: null,
          code: error?.response?.status,
          stamp: new Date()
        };
      });
  }

  static async verifyUserOtpv2(
    otp
  ) {

    return AuthProvider.STATE.makeServiceCall(
      `${AuthProvider.BASE_URL_V2}otp/user/status`,
      {
        method: 'POST',
        headers: {},
        bodyParams: {
          'id': AuthProvider.getMsisdn(),
          'pto': otp
        },
        mapper: mapVerifyUserOtpv2
      }
    )
      .then((res) => {

        if (!res.result) {

          return {
            ok: false,
            error: new Error('Error with verifyUserOtpv2, no result property found'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        setStorageWithExpiry('Auth', 'token', res.result.access_token);

        return res;
      })
      .catch((error) => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: error?.response?.data?.result,
          code: error?.response?.status,
          stamp: new Date()
        };
      });
  }
}
